// src/services/firebaseAuth.js
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../lib/firebase";

export const firebaseLogin = async (email, password) => {
  const userCredential = await signInWithEmailAndPassword(
    auth,
    email,
    password
  );

  const token = await userCredential.user.getIdToken();


  return token;
};